class ImageSlider extends HTMLElement {
  constructor() {
    super();
    this.desktopSlider = null;
    this.mobileSlider = null;
  }

  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.initDesktopSlider();
    this.initMobileSlider();
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('load', () => {
      if (this.desktopSlider) equalizeSlideHeights(this.desktopSlider);
      if (this.mobileSlider) equalizeSlideHeights(this.mobileSlider);
    });
  }

  initDesktopSlider() {
    const desktopContainer = this.querySelector('[data-image-slider-desktop]');
    if (!desktopContainer) return;

    this.desktopSlider = new Flickity(desktopContainer, {
      accessibility: true,
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: true,
      wrapAround: false,
      adaptiveHeight: false,
      draggable: true
    });

    equalizeSlideHeights(this.desktopSlider);
  }

  initMobileSlider() {
    const mobileContainer = this.querySelector('[data-image-slider-mobile]');
    if (!mobileContainer) return;

    this.mobileSlider = new Flickity(mobileContainer, {
      accessibility: true,
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: true,
      wrapAround: false,
      adaptiveHeight: false,
      draggable: true
    });

    equalizeSlideHeights(this.mobileSlider);
  }

  handleResize() {
    if (this.desktopSlider) {
      equalizeSlideHeights(this.desktopSlider);
    }
    if (this.mobileSlider) {
      equalizeSlideHeights(this.mobileSlider);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('load', () => {
      if (this.desktopSlider) equalizeSlideHeights(this.desktopSlider);
      if (this.mobileSlider) equalizeSlideHeights(this.mobileSlider);
    });
    if (this.desktopSlider) {
      this.desktopSlider.destroy();
    }
    if (this.mobileSlider) {
      this.mobileSlider.destroy();
    }
  }
}

customElements.define('image-slider', ImageSlider); 